/**
 * 카테고리 상수
 *
 * 레거시 dangil_frontend/src/constants/menu.js에서 마이그레이션
 * 백엔드 idCategory(숫자)와 1:1 매핑
 */

export interface SubCategory {
  id: number;
  label: string;
}

export interface Category {
  /** 백엔드 idCategory (0 = 전체) */
  id: number;
  label: string;
  /** 특수 카테고리: 별도 경로로 이동 */
  href?: string;
  highlight?: boolean;
  /** 기본 정렬 (지정 없으면 popular) */
  defaultOrder?: string;
  subcategories?: SubCategory[];
}

export const CATEGORIES: Category[] = [
  { id: 0, label: "전체" },
  {
    id: 14,
    label: "시즌상품",
    subcategories: [
      { id: 147, label: "크리스마스" },
      { id: 152, label: "새해" },
      { id: 153, label: "가정의 달" },
      { id: 149, label: "여름휴가" },
      { id: 158, label: "추석" },
    ],
  },
  { id: 146, label: "신제품", defaultOrder: "latest" },
  {
    id: 1,
    label: "홈 인테리어",
    subcategories: [
      { id: 101, label: "인테리어 소품" },
      { id: 155, label: "티슈케이스/리빙박스" },
      { id: 156, label: "생활용품" },
      { id: 106, label: "포스터/액자" },
      { id: 103, label: "패브릭" },
      { id: 105, label: "플라워/식물" },
      { id: 102, label: "자석/마그넷" },
      { id: 104, label: "트레이" },
      { id: 110, label: "러그/카페트/매트" },
      { id: 112, label: "인형/오브제" },
    ],
  },
  {
    id: 2,
    label: "주방용품",
    subcategories: [
      { id: 114, label: "컵/잔/텀블러" },
      { id: 115, label: "접시/그릇" },
      { id: 113, label: "주방 패브릭" },
      { id: 117, label: "주방 잡화" },
      { id: 116, label: "식기/조리도구" },
      { id: 118, label: "테이블 매트" },
    ],
  },
  {
    id: 4,
    label: "키링",
    subcategories: [{ id: 121, label: "키링" }],
  },
  {
    id: 6,
    label: "문구류",
    subcategories: [
      { id: 127, label: "카드/편지지/엽서" },
      { id: 125, label: "노트/메모장" },
      { id: 126, label: "마스킹 테이프/스티커" },
      { id: 128, label: "기타 문구류" },
    ],
  },
  {
    id: 5,
    label: "캔들/방향제/인센스",
    subcategories: [
      { id: 122, label: "캔들" },
      { id: 124, label: "방향제/인센스 스틱/향수" },
      { id: 123, label: "석고방향제" },
    ],
  },
  {
    id: 7,
    label: "악세서리",
    subcategories: [
      { id: 131, label: "헤어 액세서리" },
      { id: 130, label: "반지" },
      { id: 129, label: "목걸이" },
      { id: 154, label: "팔찌" },
      { id: 132, label: "귀걸이/차키링/북마크" },
    ],
  },
  {
    id: 9,
    label: "가방/파우치",
    subcategories: [
      { id: 138, label: "가방/파우치" },
      { id: 139, label: "카드지갑" },
    ],
  },
  {
    id: 10,
    label: "스마트톡/케이스",
    subcategories: [
      { id: 140, label: "스마트톡" },
      { id: 141, label: "에어팟/버즈케이스" },
      { id: 144, label: "폰케이스" },
      { id: 157, label: "디지털 악세서리" },
    ],
  },
  { id: 11, label: "패션", subcategories: [{ id: 145, label: "패션" }] },
  { id: 12, label: "식품류", subcategories: [{ id: 151, label: "식품류" }] },
];

/** idCategory로 카테고리 찾기 (서브카테고리 포함) */
export function findCategoryById(id: number): Category | SubCategory | undefined {
  for (const cat of CATEGORIES) {
    if (cat.id === id) return cat;
    for (const sub of cat.subcategories ?? []) {
      if (sub.id === id) return sub;
    }
  }
  return undefined;
}

/** 서브카테고리 ID → 상위(부모) 카테고리 반환 */
export function findParentCategory(id: number): Category | undefined {
  for (const cat of CATEGORIES) {
    if (cat.id === id) return cat;
    for (const sub of cat.subcategories ?? []) {
      if (sub.id === id) return cat;
    }
  }
  return undefined;
}
